export const base = {
  arrow: false,
  delay: [800, 100],
  duration: [140, 80],
  maxWidth: '18rem',
  offset: [0, 10],
  placement: 'top',
  theme: 'tooltip',
  touch: 'hold',
  trigger: 'mouseenter focus'
}

export const tooltip = {
  ...base
}

export const info = {
  ...base,
  theme: 'info'
}

export const onboarding = {
  ...base,
  theme: 'onboarding'
}
